module.exports = __webpack_public_path__ + "img/candidate_detail_new.9560e303.svg";